import { Box, BoxProps, ColorOptions, Icon, Text, TextProps } from '@jfs/ui-new';
import { convertHexToRGBA } from '@jfs/ui-new/src/utils/utils';
import { FC } from 'react';

const ModalHeader: FC<{ title: string; onDismiss: () => void; theme: any; borderBottomWidth?: any }> = ({
  title,
  onDismiss,
  theme,
  borderBottomWidth = 1,
}: {
  title: string
  onDismiss: () => void
  theme: any
  borderBottomWidth?: any
}) => {
  const style = styles(theme)
  return (
    <>
      <Box {...style.container}>
        <Text {...style.headerText}>{title}</Text>
        <Box testID="close-modal" onPress={onDismiss} underlayColor="TRANSPARENT">
          <Icon id={'CLOSE'} {...style.icon} />
        </Box>
      </Box>
      <Box height={borderBottomWidth} backgroundColor={convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions} />
    </>
  )
}

const styles = (theme: any) => ({
  container: {
    paddingHorizontal: 16,
    paddingTop: 32,
    paddingBottom: 16,
    flexDirection: 'row',
    backgroundColor: theme.bodyBgColor as ColorOptions,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    justifyContent: 'space-between',
  } as BoxProps,
  headerText: {
    fontSize: 14,
    fontWeight: '700',
    color: theme.bodyTextColor as ColorOptions,
  } as TextProps,
  icon: {
    fontSize: 16,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
  },
})
export { ModalHeader };

